module.exports = __webpack_public_path__ + "static/media/Rumah Tjempaka (1).99d10fce.png";